import { useMutation } from '@tanstack/react-query';
import { MutationKey } from '@shared/config';
import { authApi } from '../../authApi';
import type { SurferRegistrationResendRequest } from '../../types';

export const useResendSurferRegistrationCode = () =>
  useMutation({
    mutationKey: [MutationKey.AUTH_SURFER_REGISTER_RESEND_CODE],
    mutationFn: (payload: SurferRegistrationResendRequest) =>
      authApi.resendSurferRegistrationCode(payload),
  });
